export * from "./validateBadgeData";
